<template>
  <div>
    <BContainer ref="bcon">
      <div class="columns">
        <div class="column is-1">
          <b-field grouped group-multiline>
            <a class="button is-primary" @click="openEditModal(null)">{{ $t('button.new') }}</a>
          </b-field>
        </div>
        <div class="column">
          <b-field grouped group-multiline class="is-pulled-right">
            <input
              style="width:150px; height:20px; margin-top:7px;"
              type="file"
              @change="onChangeExcelFile"
            />
            <xlsx-read :file="excelFile">
              <xlsx-json @parsed="excelFileParsed"></xlsx-json>
            </xlsx-read>
            <a class="button is-primary" @click="insertBulk" :disabled="bulkInsertDisabled">
              {{ $t('button.upload') }}
            </a>
          </b-field>
        </div>
      </div>

      <b-table :data="questions" :striped="true" :hoverable="true" :mobile-cards="true">
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric :visible="false">
            {{ props.row.id }}
          </b-table-column>
          <b-table-column field="no" label="No" width="40" numeric>
            {{ props.row.no }}
          </b-table-column>
          <b-table-column field="name" :label="$t('validation.attributes.name')">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column
            v-if="!isProcessGroup"
            field="financialReportRaw"
            :label="$t('title.financialReport')"
            numeric
          >
            {{ props.row.financialReportRaw }}
          </b-table-column>
          <b-table-column
            v-if="!isProcessGroup"
            field="adaptationRaw"
            :label="$t('title.adaptation')"
            numeric
          >
            {{ props.row.adaptationRaw }}
          </b-table-column>
          <b-table-column
            v-if="!isProcessGroup"
            field="operationRaw"
            :label="$t('title.operation')"
            numeric
          >
            {{ props.row.operationRaw }}
          </b-table-column>
          <b-table-column
            v-if="!isProcessGroup"
            field="abuseRaw"
            :label="$t('title.abuse')"
            numeric
          >
            {{ props.row.abuseRaw }}
          </b-table-column>
          <b-table-column>
            <div class="buttons">
              <b-button icon-right="edit" @click="openEditModal(props.row.id)" />
              <b-button icon-right="trash-alt" @click="deleteQuestion(props.row.id)" />
            </div>
          </b-table-column>
        </template>
      </b-table>
    </BContainer>
  </div>
</template>

<script>
import { XlsxRead, XlsxJson } from '../../../../../node_modules/vue-xlsx/dist/vue-xlsx.es'
import ApiService from '../../../../_api/api.service'
import QuestionEdit from './QuestionEdit.vue'

export default {
  components: {
    XlsxRead,
    XlsxJson
  },
  data () {
    return {
      questions: [],
      processId: null,
      isProcessGroup: false,
      excelFile: null,
      bulkInsertDisabled: true,
      bulkQuestionsData: []
    }
  },
  async mounted () {
    this.processId = this.$route.params.processId
    await this.getQuestions()
  },
  methods: {
    async getQuestions () {
      const process = await ApiService.get(`/process/${this.processId}`)
      this.isProcessGroup = process.processGroupId !== null
      this.questions = await ApiService.get(`/process/${this.processId}/question`)
    },
    insertBulk () {
      ApiService.post(`/process/${this.processId}/question/bulk`, {
        questions: this.bulkQuestionsData
      }).then(() => {
        this.bulkInsertDisabled = true
        this.excelFile = null
        this.getQuestions()
      })
    },
    openEditModal (questionId) {
      this.$buefy.modal.open({
        parent: this,
        props: { questionId, processId: this.processId, isProcessGroup: this.isProcessGroup },
        component: QuestionEdit,
        events: {
          saved: () => {
            this.getQuestions()
          }
        }
      })
    },
    deleteQuestion (questionId) {
      this.$buefy.dialog.confirm({
        title: this.$t('title.deletingQuestion'),
        message: this.$t('description.deletingQuestionConfirmMessage'),
        confirmText: this.$t('button.deleteQuestion'),
        cancelText: this.$t('button.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          ApiService.delete(`/process/${this.processId}/question`, { data: { questionId } }).then(
            isDeleted => {
              if (isDeleted) {
                this.questions = []
                this.getQuestions()
              } else {
                this.deleteQuestion(questionId)
              }
            }
          )
        }
      })
    },
    onChangeExcelFile (event) {
      this.excelFile = event.target.files ? event.target.files[0] : null
    },
    excelFileParsed (parsedData) {
      this.bulkQuestionsData = parsedData.map(question => {
        question.no = question.No || question.no
        question.name = (question['Denetim Sorusu'] || question.name || '').trim()
        question.description = (question['Açıklama'] || question.description || '').trim()
        question.financialReportRaw = question['Finansal Raporlama'] || question.financialReportRaw
        question.adaptationRaw = question.Uyum || question.adaptationRaw
        question.operationRaw = question['Operasyonel Etkinlik'] || question.operationRaw
        question.abuseRaw = question.Suistimal || question.abuseRaw
        question.component = (question['Kontrol Bileşeni'] || question.component || '').trim()

        switch (question.component) {
          case 'Control Environment':
            question.componentId = 1
            break
          case 'Kontrol Ortamı':
            question.componentId = 1
            break
          case 'Risk Assessment':
            question.componentId = 2
            break
          case 'Risk Değerlendirme':
            question.componentId = 2
            break
          case 'Control Activities':
            question.componentId = 3
            break
          case 'Kontrol Aktiviteleri':
            question.componentId = 3
            break
          case 'Information & Communication':
            question.componentId = 4
            break
          case 'Bilgi ve İletişim':
            question.componentId = 4
            break
          case 'Monitoring':
            question.componentId = 5
            break
          case 'Gözetim ve İzleme':
            question.componentId = 5
            break
          default:
            break
        }
        delete question.component
        return question
      })
      this.bulkInsertDisabled = false
    }
  }
}
</script>
